"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.locales = exports.defaultLocale = void 0;
var _extends3 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _enums = require("./enums");
var localesById = Object.keys(_enums.LocaleId).reduce(function (acc, id) {
  var _extends2;
  return (0, _extends3.default)({}, acc, (_extends2 = {}, _extends2[id] = {
    id: _enums.LocaleId[id],
    path: _enums.LocalePath[id],
    lang: _enums.LocaleLang[id]
  }, _extends2));
}, {} // we know the end-result of this
);
var locales = exports.locales = Object.values(localesById);
var defaultLocale = exports.defaultLocale = localesById[_enums.LocaleId.global];